import axios, { AxiosInstance, AxiosResponse } from 'axios';
import axiosRetry from 'axios-retry';
import { errorInterceptor } from './ErrorInterceptor';
import { CustomerId, SiteId } from '../types';
import withJWTRefreshment from './TokenService/withJWTRefreshment';

import { injectTokenToConfig } from './TokenService/injectTokenToConfig';
import { retryCondition } from './retryCondition';
import {
  AvailableScheduleDatesResponse,
  RescheduleRequestPayload,
  RescheduleRequestResponse,
} from '../types/flightSchedule.types';

class FlightScheduleService {
  flightScheduleService: AxiosInstance;

  constructor(flightScheduleServiceBaseUrl: string) {
    this.flightScheduleService = axios.create({
      baseURL: flightScheduleServiceBaseUrl,
    });
    this.flightScheduleService = withJWTRefreshment(this.flightScheduleService);

    axiosRetry(this.flightScheduleService, {
      retries: 10,
      retryDelay: axiosRetry.exponentialDelay,
      retryCondition,
    });

    this.flightScheduleService.interceptors.response.use(
      (res) => res,
      (err) => errorInterceptor(err),
    );
  }

  async getAvailableDates(customerId: CustomerId, siteId: SiteId, scheduleId: string) {
    const config = await injectTokenToConfig(
      {},
      {
        customer: customerId,
        site: siteId,
      },
    );

    return this.flightScheduleService
      .get(`/api/v1/reschedules/${customerId}/${siteId}/available_dates/${scheduleId}`, {
        ...config,
      })
      .then((response: AxiosResponse<AvailableScheduleDatesResponse>) => {
        return response.data;
      });
  }

  async createRescheduleRequest(customerId: CustomerId, siteId: SiteId, payload: RescheduleRequestPayload) {
    const config = await injectTokenToConfig(
      {},
      {
        customer: customerId,
        site: siteId,
      },
    );

    return this.flightScheduleService
      .post(`/api/v1/reschedules/${customerId}/${siteId}/`, payload, {
        ...config,
      })
      .then((response: AxiosResponse<RescheduleRequestResponse>) => {
        return response.data;
      });
  }
}

const flightScheduleClient = new FlightScheduleService(FlightScheduleApiUrl);

export const getFlightScheduleService = () => {
  return flightScheduleClient;
};
